<div class="mb-3 mt-2">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item" role="presentation">
      <button
        class="nav-link active"
        id="conditions-tab"
        data-bs-toggle="tab"
        data-bs-target="#conditions"
        type="button"
        role="tab"
        aria-controls="conditions"
        aria-selected="true">
        Conditions
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="flowactions-tab"
        data-bs-toggle="tab"
        data-bs-target="#flowactions"
        type="button"
        role="tab"
        aria-controls="flowactions"
        aria-selected="false">
        Actions
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button
        class="nav-link"
        id="trigger-tab"
        data-bs-toggle="tab"
        data-bs-target="#trigger"
        type="button"
        role="tab"
        aria-controls="trigger"
        aria-selected="true">
        Triggers
      </button>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane" id="trigger" role="tabpanel" aria-labelledby="trigger-tab">
      <div class="mb-2">
        <div class="position-relative my-2">
          <i class="pi pi-search search-Icon"></i>
          <input type="text" (input)="FilterSearchTaskList($event.target.value)" placeholder="Search Automations" class="search-Input" />
        </div>
        <div class="mt-2">
          <ul>
            <ng-container *ngFor="let item of tempTriggerList; let i = index">
              <ng-container *ngIf="item?.type === WFS?.TaskList?.type">
                <li class="list match-trigger" (dblClick)="triggerEmitter(item)" appDoubleClick>
                  <i [ngStyle]="{ 'background-color': item?.canStart ? '#6fd8cf' : '#76828F' }"></i>
                  <div class="d-flex flex-column overflow-hidden">
                    <p class="text-truncate f-10">{{ item.tigger_title }}</p>
                    <div class="font-normal f-10">{{ WFS?.GetAlteredModuleName(item?.module) }}</div>
                  </div>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab-pane active" id="conditions" role="tabpanel" aria-labelledby="conditions-tab">
      <div class="mb-2">
        <div class="mt-2">
          <ul>
            <ng-container *ngFor="let item of WFS.condition_array; let i = index">
              <li class="list {{ item.class }}" (dblClick)="triggerEmitter(item)" appDoubleClick>
                <i class="{{ item.icon }}" style="color: #fcae1e"></i> {{ item.name }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="flowactions" role="tabpanel" aria-labelledby="flowactions-tab">
      <div class="mb-2">
        <div class="mt-2">
          <ul>
            <ng-container *ngFor="let item of WFS.action_list; let i = index">
              <li class="list {{ item.class }}" (dblClick)="triggerEmitter(item)" appDoubleClick>
                <i class="{{ item.icon }}" style="color: #3cb043"></i> {{ item.name }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
